import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  name: {
    default: 'exampleName',
    editor: 'textbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  placeholder: {
    default: 'Select a time...',
    editor: 'textbox',
  },
  value: {
    default: '',
    editor: 'textbox',
  },
};

const TimeStory: Story = {
  title: 'Time picker',
  description: 'A simple mobile time input element with various attributes',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-time-input {{...knobs}} ></tag3-mobile-time-input>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'HH:mm',
        editor: 'textbox',
      },
      placeholder: {
        default: 'Select a time...',
        editor: 'textbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileTimeInput {{...knobs}}></TagMobileTimeInput>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'HH:mm',
        editor: 'textbox',
      },
      placeholder: {
        default: 'Select a time...',
        editor: 'textbox',
      },
    },
  },
};

const ValidationStory: Story = {
  title: 'With validation',
  description:
    'A simple mobile time input element with various attributes, with required validation enabled',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-time-input {{...knobs}} ></tag3-mobile-time-input>
  <tag3-validator
    source-element="tag3-mobile-time-input input"
    source-root-element="tag3-mobile-time-input"
    source-element-value-prop="value"
    trigger-element-event="blur"
    rule="required"
    error-element=".entityName-input-error"
  ></tag3-validator>
  <tag3-validation-alert class="entityName-input-error" device="mobile">
      You must choose a value to hide this
  </tag3-validation-alert>
</div>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileTimeInput {{...knobs}}></TagMobileTimeInput>
  <Tag3Validator 
    sourceElement="tag3-mobile-time-input input"
    sourceRootElement="tag3-mobile-time-input"
    sourceElementValueProp='value'
    triggerElementEvent='blur'
    rule='required' 
    errorElement='.entityName-input-error' />
  <Tag3ValidationAlert className='entityName-input-error' device="mobile">
    You must choose a value to hide this
  </Tag3ValidationAlert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

export const TagMobileTimeInputDocs: Component = {
  type: 'component',
  name: 'mobile-time-input',
  description: 'Renders a mobile time input element. This will ONLY work on a mobile device.',
  mobileFriendly: true,
  popular: false,
  preRelease: 'beta',
  props: [
    {
      name: 'name',
      description: 'The name of the field',
      type: 'string',
    },
    {
      name: 'inputId',
      description: 'The id of the input field',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'disabled',
      description: 'Whether the input selection is disabled or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'formattingOptions',
      description:
        'Formatting options for times, e.g. "HH:mm", "hh:mm a". This maps directly to the format parameter in Day.Js see https://day.js.org/docs/en/display/format',
      type: 'string',
      default: 'HH:mm',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'mobileTimeInputValueChange',
      description: 'Triggers when the field value changes',
      parameters: [
        {
          name: 'time',
          description: 'The time component of the date',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [TimeStory, ValidationStory],
};
